import { CheckInTemplateDetails, CheckInTemplateQuestion } from './checkIn';

export class EngagementTemplateDetails extends CheckInTemplateDetails {}

export class EngagementTemplateQuestion extends CheckInTemplateQuestion {}
